/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_Referral_LinkInputs */

const en_your_referral_link = /** @type {(inputs: Your_Referral_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Referral Link`)
};

const es_your_referral_link = /** @type {(inputs: Your_Referral_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu enlace de referencia`)
};

const fr_your_referral_link = /** @type {(inputs: Your_Referral_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre lien de parrainage`)
};

const de_your_referral_link = /** @type {(inputs: Your_Referral_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Empfehlungslink`)
};

const ja_your_referral_link = /** @type {(inputs: Your_Referral_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたの紹介リンク`)
};

const zh_your_referral_link = /** @type {(inputs: Your_Referral_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的推荐链接`)
};

const ar_your_referral_link = /** @type {(inputs: Your_Referral_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رابط الإحالة الخاص بك`)
};

const id_your_referral_link = /** @type {(inputs: Your_Referral_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan Referal Anda`)
};

const it_your_referral_link = /** @type {(inputs: Your_Referral_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il Tuo Link di Invito`)
};

const ru_your_referral_link = /** @type {(inputs: Your_Referral_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша реферальная ссылка`)
};

const pt_your_referral_link = /** @type {(inputs: Your_Referral_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu Link de Indicação`)
};

const ko_your_referral_link = /** @type {(inputs: Your_Referral_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 추천 링크`)
};

/**
* | output |
* | --- |
* | "Your Referral Link" |
*
* @param {Your_Referral_LinkInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const your_referral_link = /** @type {((inputs?: Your_Referral_LinkInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_Referral_LinkInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_your_referral_link(inputs)
	if (locale === "es") return es_your_referral_link(inputs)
	if (locale === "fr") return fr_your_referral_link(inputs)
	if (locale === "de") return de_your_referral_link(inputs)
	if (locale === "ja") return ja_your_referral_link(inputs)
	if (locale === "zh") return zh_your_referral_link(inputs)
	if (locale === "ar") return ar_your_referral_link(inputs)
	if (locale === "id") return id_your_referral_link(inputs)
	if (locale === "it") return it_your_referral_link(inputs)
	if (locale === "ru") return ru_your_referral_link(inputs)
	if (locale === "pt") return pt_your_referral_link(inputs)
	return ko_your_referral_link(inputs)
});